import { Button, CircularProgress, FormControl, FormHelperText, Grid, IconButton, Tooltip } from "@mui/material";
import { IconCloudUpload, IconX } from "@tabler/icons";
import React, { useState } from "react";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { FileApi, UploadFileRequest } from "../../api/file-management";
import { configState } from "../../recoil/atoms";
import useAuthorization from "../../pages/Authentication/permissions/Authorization";
import { toast } from "react-toastify";
import { ErrorMessage, useField, useFormikContext } from "formik";

export default function UploadField(props: any) {
  const { name, fileType, label } = props;
  const { setFieldValue } = useFormikContext();
  const config = useRecoilValue(configState);
  const [field] = useField(props);
  const [url, setURL] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { canUploadFile, canDeleteFile, canGetFile } = useAuthorization();

  const uploadFile = (values: UploadFileRequest) => {
    const files = new FileApi(config);
    files
      .uploadFileForm(values.Type, values.File)
      .then((res) => {
        setIsLoading(false);
        setFieldValue(name, res.data.UUID);
        getFile(res.data.UUID);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.detail);
        setFieldValue(name, undefined);
      });
  };

    const resetFile = () => {
        setFieldValue(name, undefined);
        setURL("");
    };


  const getFile = (uuid: string) => {
    const files = new FileApi(config);
    files
      .getFile(uuid!, config!.apiKey!.toString())
      .then((res) => {
        setURL(res.config.url!);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
        setFieldValue(name, undefined);
      });
  };

  useEffect(() => {
    if (field.value) getFile(field.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value]);

  return (
    <>
      {field.value && canGetFile ? (
        <Grid container sx={{ justifyContent: "center", alignContent: "center" }}>
          <Grid item>
            <a href={url} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                View {label}
            </a>
              {canDeleteFile && (
                  <Tooltip title="Delete">
                      <IconButton onClick={resetFile} style={{ marginLeft: 3 }}>
                          <IconX color="red" />
                      </IconButton>
                  </Tooltip>
              )}
          </Grid>
        </Grid>
      ) : (
        <>
          {canUploadFile &&
            (!isLoading ? (
              <FormControl {...props} error={true}>
                <Button variant="contained" component="label" color="info" sx={{ mt: 1 }}>
                  <IconCloudUpload style={{ marginRight: 10 }} /> Upload {label}
                  <input
                    id="file"
                    name={name}
                    hidden
                    type="file"
                    accept="application/pdf,image/*"
                    onChange={(event: any) => {
                      setIsLoading(true);
                      uploadFile({ Type: fileType, File: event!.currentTarget!.files[0] });
                    }}
                  />
                </Button>
                <FormHelperText>
                  <ErrorMessage name={name} />
                </FormHelperText>
              </FormControl>
            ) : (
              <>
                <Grid container sx={{ justifyContent: "center", alignContent: "center" }}>
                  <Grid item>
                    Uploading Image
                    <CircularProgress
                      color="secondary"
                      size={14}
                      sx={{
                        ml: { xs: 0, xl: 3 },
                        mt: 2,
                      }}
                    />
                  </Grid>
                </Grid>
              </>
            ))}
        </>
      )}
    </>
  );
}
